//
// Copyright (c) 2011-2020 by Curalate, Inc.
//

import { createSelector } from 'reselect';

import { ICuralateStore } from '@models/AppState';
import { getAreNoGalleriesSelectedImpl } from '@galleries/selectors/bulk-rights-selectors/getAreNoGalleriesSelected';

export const getAreNoGalleriesSelected = createSelector(
  (state: ICuralateStore) =>
    state.uiaModal.approveForGalleries.gallerySelection,
  getAreNoGalleriesSelectedImpl,
);

export default getAreNoGalleriesSelected;
